// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		suggestionStyle: 'style2',
		suggestionMobileStyle: 'style2'
	},
	selector: {
		otpButtons: '.product-card__content .product-card__description'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {};

	SearchInput.prototype.afterBindEvents = function() {
		// Fix cannot close search suggestion when clicking overlay
		document.addEventListener('click', function(e) {
			if(this.searchAutoComplete && this.searchAutoComplete.isOpen && e && e.target) {
				var $clickedElement = jQ(e.target);
				var isClickSuggestion = $clickedElement.closest('.' + Class.searchSuggestionWrapper).length > 0;
				if (isClickSuggestion) {
					this.searchAutoComplete.$element.hide();
					this.searchAutoComplete.searchInput.onCloseAutocomplete();
					this.searchAutoComplete.isOpen = false;
				}
			}
		}.bind(this), true);
	}

	InstantSearchResultItemProduct.prototype.afterRender = function () {
		if (!this.data || !this.isShow) return

		var tag = this.data.tags;

		var metafields = this.data.metafields;

		if (tag.indexOf('epos:call-for-price:true') !== -1 || tag.indexOf('epos:call-for-price:1') !== -1 || metafields.find(metafield => metafield.key == "price_on_request" && metafield.value == "true")) {
			this.$element.find('.boost-pfs-search-suggestion-product-price').remove();
		} else {
			const discountTags = this.data.tags.filter((tag) => {
				const tagLow = tag.toLowerCase();
				return tagLow.startsWith('discount-') || (tagLow.startsWith('sticker:') && tagLow.includes('% off'))
			});

			let compareAtPrice = this.data.compare_at_price_min;
			let price = this.data.price_min;
			let stickerPrice = price;

			discountTags.forEach((tag) => {
				const tagLow = tag.toLowerCase();
				let discountedPrice = stickerPrice;
				if (tagLow.startsWith('discount-')) {
				const discountValue = Number(tagLow.replace('discount-',''));
				if (isNaN(discountValue)) return;
				discountedPrice = price - discountValue;
				} else {
				const discountPercent = Number(tagLow.split('% off')[0].split(':').reverse()[0]);
				if (isNaN(discountPercent) || discountPercent <= 0 || discountPercent > 100) return;
				discountedPrice = Math.ceil(price * (100 - discountPercent)) / 100;
				}
				
				if (discountedPrice < stickerPrice) {
				stickerPrice = discountedPrice;
				}
			});

			if (stickerPrice < price) {
				compareAtPrice = price;
				price = stickerPrice;
			}

			if (compareAtPrice > price) {
				this.$element.find('.boost-pfs-search-suggestion-product-price')
				.html(`<div class="boost-pfs-search-suggestion-product-sale-price">
					<span>${Utils.formatMoney(price)}</span>
					<s>${Utils.formatMoney(compareAtPrice)}</s>
				</div>`);
			}
		}

		var productUrl = '/products/' + Utils.buildProductItemUrlWithVariant(this.data).split('/products/')[1];
		this.$element.find('.boost-pfs-search-suggestion-item > a')[0].href = productUrl;

		/*var imagesQuantity = Object.keys(this.data.images).length

		if(imagesQuantity < 1) {
			var image = this.$element.find('img');

			image.src = Utils.optimizeImage('https:'+ boostPFSSearchConfig.fallback_image, '100x');
			console.log('image', image);

		}*/

	}
})();
